const messages = {
  title: "Bonus",
  word: "Bonus",
  description: "Les entreprises participantes reçoivent des crédits sous forme de remises basées sur les chiffres de ventes transmis.",
};

export default {
  messages,
};
